<template>
  <div class="login-container" align="center">
    <!-- <div class="login-img">
      <img src="../assets/login.png" width="100%">
    </div> -->
    <div class="login-box"  >
      <div class="login-header">
        <h3>{{sysName}}</h3>
      </div>
      <div class="login-content">
        <h-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left" class="card-box login-form">
          <h4>用户登录<h-icon name="mine" colcor="red"></h-icon></h4>
          <h-form-item prop="username">
            <h-input name="username" type="text" v-model="loginForm.username" autocomplete="on" placeholder="用户名" ref='username'>
              <h-icon name="mine" slot="prepend"></h-icon>
            </h-input>
            <div class="verify-tip verify-bottom" v-show='userError'>
              <div class="verify-tip-arrow"></div>
              <div class="verify-tip-inner">{{userErrorInfo}}</div>
            </div>
          </h-form-item>
          <h-form-item prop="password">
            <h-input name="password" type="password" v-model="loginForm.password" autocomplete="on" placeholder="密码" ref='password'>
              <h-icon name="lock" slot="prepend"></h-icon>
            </h-input>
            <div class="verify-tip verify-bottom" v-show='passError'>
              <div class="verify-tip-arrow"></div>
              <div class="verify-tip-inner">{{passErrorInfo}}</div>
            </div>
          </h-form-item>
          <h-form-item prop="checkcode">
            <h-input name="checkcode" type="text" @keyup.enter.native="handleLogin" v-model="loginForm.checkcode" autocomplete="on" placeholder="验证码" ref="checkcode" class="checkInput"></h-input>
            <div class="checkcode">
              <img id="codeimg" width="100px" height="40px" @click="refreshCode" style="cursor: pointer;" title="点击这里刷新验证码">
            </div>
              <div class="verify-tip verify-bottom" v-show='codeError'>
                <div class="verify-tip-arrow"></div>
                <div class="verify-tip-inner">{{codeErrorInfo}}</div>
              </div>
          </h-form-item>
          <h-form-item style="margin-bottom: 0;overflow: hidden;">
            <h-button type="primary" style="float: left; width:49%;" :loading="loading" @click.native.prevent="handleLogin">
              登录
            </h-button>
            <h-button type="primary" style="float: left;width:49%;margin-left:2%;" @click="userHandleLogin">
              ISV登录
            </h-button>
          </h-form-item>
        </h-form>
      </div>
    </div>
    <div class="login-footer">@2019 浙江鲸腾网络科技有限公司</div>
  </div>
</template>
<script>
import fetch from '../api/httpFetch.js'
import { asyncRouterMap, constantRouterMap } from '@/router'
 import {rServiceValidate} from "@/api/bizApi/commonUtil";

export default {
  name: 'login',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    return {
       URL:'',
      ticket:'',
      service:'',
      loginForm: {
        username: '',
        password: '',
        checkcode: ''
      },
      randomCode: '',
      loginRules: {
        checkcode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur',
          // validator: validatePass
        }],
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }]
      },
      loading: false,
      showDialog: false,
      userError: false,
      userErrorInfo: '',
      codeError: false,
      codeErrorInfo: '',
      passError: false,
      passErrorInfo: '',
      sysName: this.LOCAL_CONFIG.SYS_NAME
    }
  },
  watch: {
    loginForm: {
      handler: function() {
        this.userError = false
        this.passError = false
        this.loading = false
        this.codeError = false
      },
      deep: true
    }
  },
  methods: {
     
    GetQueryString(name) {
      //获取URL参数
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    handleLogin() {
    
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('Login', this.loginForm).then((res) => {
            this.loading = false;
           if(res.data.errcode=='0'){
            
            this.$router.push({ path: '/mainIndex' });
            }else{
              this.refreshCode();
            }

            // console.log("跳转到主页")
          }).catch(err => {
            this.loading = false;
            let code = err.response.data['errorcode']
            let msg = err.response.data['errormsg']
            if (code == '100' || code == '101') {
              this.$refs.checkcode.focus();
            } else if (code == '102') {
              this.$refs.password.focus();
            }
            this.$message({
              message: msg,
              type: 'error'
            })
            this.loginForm.checkcode = ''
            this.createCode()
          })
        } else {
          return false
        }
      })
    },
    refreshCode() {

      this.createCode();
      this.loginForm.checkcode='';
    },
    codeBlur() {
      var checkCodeToken = this.randomCode;
      if (this.loginForm.checkcode == "") {
        this.codeErrorInfo = "验证码不能为空";
        this.codeError = true;
      }
      if (this.loginForm.checkcode != checkCodeToken) {
        this.codeErrorInfo = "验证码不正确";
        this.codeError = true;
      }
    },
    nameBlur() {
      if (this.loginForm.username == "") {
        this.userErrorInfo = "用户名不能为空";
        this.userError = true;
      } else {
        fetch.get('/getSecurityKey.json').then(response => {
          if (response) {
            var key1 = response.data.key1;
            var key2 = response.data.key2;
            var key3 = response.data.key3;
            var loginName = BizSecurity.DES.encrypt(this.loginForm.username, key1, key2, key3);
            fetch.post('/checkUserNameOrPwd.json', { flag: 1, loginName: loginName }).then(res => {
              if (res) {
                var data = res.data;
                if (data[this.LOCAL_CONFIG.SUCCESS_KEY] != '0') {
                  this.userErrorInfo = data.return_info;
                  this.userError = true;
                }
              }
            })
          }
        })
      }
    },
    //用户中心登录按钮
    userHandleLogin(){
      this.$router.push({path:'/loginIndex'})
      sessionStorage['userType'] = 0;

    },

    pwdBlur() {
      if (this.loginForm.password == "") {
        this.passErrorInfo = "密码不能为空";
        this.passError = true;
      } else {
        if (this.loginForm.username == "") return;
        fetch.get('/getSecurityKey.json').then(response => {
          if (response) {
            var key1 = response.data.key1;
            var key2 = response.data.key2;
            var key3 = response.data.key3;
            var loginName = BizSecurity.DES.encrypt(this.loginForm.username, key1, key2, key3);
            var password = BizSecurity.DES.encrypt(this.loginForm.password, key1, key2, key3);
            fetch.post('/checkUserNameOrPwd.json', { flag: 2, loginName: loginName, password: password }).then(res => {
              if (res) {
                var data = res.data;
                if (data[this.LOCAL_CONFIG.SUCCESS_KEY] != '0') {
                  this.passErrorInfo = data.return_info;
                  this.passError = true;
                }
              }
            })
          }
        })
      }
    },
    /*生成验证码*/
    createCode() {
      // this.$store.dispatch('GetVerifyCode',uri).then((res) => {
        //   this.loading = false;
      //   console.log(res)
      //       // console.log("跳转到主页")
      //       verifyCode.src = uri;
      //     }).catch(err => {
        //        reject(error);
      //     })
      // this.data.checkcodeurl=LOCAL_CONFIG.API_HOME + '/verify_code.jpg?t=' + (new Date()).getTime();
      fetch.get('/user/verify_code').then(response => {
        sessionStorage['codeId']=response.data.data.codeId;

        var verifyCode = document.getElementById("codeimg");
        // verifyCode.src =LOCAL_CONFIG.API_HOME + '/verify_code.jpg?t=' + (new Date()).getTime();
        verifyCode.src="data:image/jgp;base64,"+response.data.data.imageIo;
      })
    }
  },
  created() {
		let xyjId=sessionStorage['xyj']||''
		if(xyjId=='xyj'){
			this.$router.replace({ path: '/clogin' });
		}
		
    document.getElementsByTagName('html')[0].style.padding='0'
    document.getElementsByTagName('html')[0].className ='theme-black'
    document.body.className = 'login'
    
  },
  mounted() {
    this.createCode()
  },
  destroyed() {
    document.body.className = ''
  }
}

</script>



// WEBPACK FOOTER //
// src/views/login.vue